import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import BenefitsSection from './components/BenefitsSection';
import ComparisonSection from './components/ComparisonSection';
import SafetySection from './components/SafetySection';
import SeoArticlesGrid from './components/SeoArticlesGrid';
import SeoArticleTeaser from './components/SeoArticleTeaser';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <WhatIsSection />
        <BenefitsSection />
        <ComparisonSection />
        <SafetySection />
        <SeoArticlesGrid />
        <SeoArticleTeaser />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}